import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Configuration } from 'src/app/Constants/configuration';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { Router } from '@angular/router';
import { RequestServices } from 'src/app/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from 'src/app/services/storage.service';
import { LogConsumoFunciones } from 'src/app/utilities/logConsumo';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';

@Component({
  selector: 'app-notificacion',
  templateUrl: './notificacion.component.html',
  styleUrls: ['./notificacion.component.css']
})
export class NotificacionComponent implements OnInit {
  public const: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public telefono: string = "";
  public logConsumoId: string = "";
  public cocheSeguro: CocheSeguro = new CocheSeguro();
  public title: String = '';
  public message: String;
  public accion: String;
  public cancel: String;
  public error: boolean = false;
  public llamar: boolean = false;
  public default: boolean = false;
  public classAccion: string = "";
  public aseguradoraID: number = 0;
  public errorAnalisis: string = "";
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);


  constructor(
    private router: Router,
    private requestService: RequestServices,
    public modalRef: MatDialogRef<NotificacionComponent>,
    private snackBar: MatSnackBar,
    private storageService: StorageService) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit() {
    this.logConsumoId = this.storageService.getItem("logConsumoId");
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    if (this.aseguradoraID > 0 && this.errorAnalisis != "") {
      this.errorAnalitic();
    }
  }

  updatelogConsumo() {
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    this.cocheSeguro.telefono = this.telefono;
    this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
    this.logConsumoFun.logConsumo()
    this.close();
  }

  obtenerAyuda() {
    let ayuda = this.logConsumoFun.ayudaInsert().subscribe(result => {
      if (result.error) {
        this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
      } else if (result.ok || result.Exist_log) {
        ayuda.unsubscribe();
        this.updatelogConsumo();
      }
    });
  }

  close() {
    this.modalRef.close({ ok: "OK" });
  }

  valida(): boolean {
    if (this.telefono == undefined || this.telefono == "" || this.telefono.length < 10) {
      return true;
    } else {
      return false;
    }
  }

  errorAnalitic() {
    switch (this.aseguradoraID) {
      case 1: // Chubb
        if (this.errorAnalisis.includes("El número de serie tecleado es incorrecto o no cumple con las validaciones correspondientes.")) {
          this.message = "El número de serie ingresado es inválido.";
        } else if (this.errorAnalisis.includes("El número de serie ya existe en la póliza")) {
          this.message = "El número de serie ya se encuentra amparado.";
        } else if (this.errorAnalisis.includes("Error de validación: Debe especificar el segundo apellido")) {
          this.message = "El Apellido Materno es obligatorio.";
        } else {
          this.message = this.errorAnalisis;
        }
        break;
      case 14:
        this.message = this.errorAnalisis;
        break;
      case 20:
        this.message = this.errorAnalisis;
        break;
      case 22: // Mapfre
        if (this.errorAnalisis.includes("Ocurrió un problema con la generación de tu póliza, revisa los datos ingresados o ponte en contacto con tu asesor.")) {
          this.message = "Ocurrió un problema con la generación de tu póliza, revisa los datos ingresados.";
        } else {
          this.message = this.errorAnalisis;
        }
        break;
      case 29: // Qualitas
        if (this.errorAnalisis.includes("Serie Reportada como robada")) {
          this.message = "El número de serie corresponde a un vehiculo reportado como robado.";
        } else {
          this.message = this.errorAnalisis;
        }
        break;
      case 31: // Afirme
        if (this.errorAnalisis.includes("Tipo de Tarjeta inválido")) {
          this.message = "No se pudieron procesar los datos de tu tarjeta correctamente.";
        } else if (this.errorAnalisis.includes("Num de tarjeta o cuenta invalida (Invalida)")) {
          this.message = "No se pudieron procesar los datos de tu tarjeta correctamente.";
        } else if (this.errorAnalisis.includes("No fue posible emitir la cotizacion, La placa es requerido")) {
          this.message = "El número de placa es obligatorio.";
        } else {
          this.message = this.errorAnalisis;
        }
        break;
      case 49: // Primero
        if (this.errorAnalisis.includes("Numero de serie") && this.errorAnalisis.includes("Registrado en una poliza vigente.")) {
          this.message = "El número de serie ya se encuentra amparado.";
        } else {
          this.message = this.errorAnalisis;
        }
        break;
    }
  }

}